import VerticalSlider from 'javascripts/utils/VerticalSlider';
import { t } from 'javascripts/utils/withTranslation';

class TwitterBox {
  constructor($box) {
    this.$box = $box;
    this.$content = $box.querySelector('.twitter-box__content');
    this.url = $box.getAttribute('data-ajaxurl');
    this.data = {
      twitterurl: $box.getAttribute('data-twitterurl'),
      lc: $box.getAttribute('data-locale'),
      L: $box.getAttribute('data-language'),
    };
    this.queryUrl = `${this.url}?twitterurl=${this.data.twitterurl}&lc=${this.data.lc}&L=${this.data.L}`;

    this.posts = this.fetchPosts();
    this.renderPosts();
  }

  fetchPosts() {
    return fetch(this.queryUrl, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'text/plain',
      },
      redirect: 'follow',
      referrer: 'no-referrer',
    }).then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.text();
    });
  }

  renderPosts() {
    this.posts.then((response) => {
      this.$content.innerHTML += response;
    }).then(() => {
      const $grid = this.$box.closest('.grid__row');
      if ($grid) {
        const gridHeight = $grid.getBoundingClientRect().height;
        const putHeight = Math.max(gridHeight, 500);
        this.$box.style.maxHeight = `${putHeight}px`;
      }
    }).then(() => {
      // move tweetList one place up in the DOM for initializing the Vertical Slider
      const $tweetList = this.$content.querySelector('.tweet-list');
      if ($tweetList) {
        $tweetList.parentNode.insertBefore($tweetList, $tweetList.previousElementSibling);
      }
    }).then(() => {
      const $tweets = this.$content.querySelectorAll('.tweet');
      if ($tweets) {
        $tweets.forEach(($tweet) => {
          $tweet.classList.add('js-verticalslider-item');
        });
      }
    })
      .then(() => new VerticalSlider(this.$box.querySelector('.js-verticalslider')))
      .catch(() => {
        this.$content.innerHTML = t('Tweets können nicht angezeigt werden.');
      });
  }
}

document.querySelectorAll('.twitter-box').forEach($box => new TwitterBox($box));
